export default function createSrcSet(sizes) {
  const srcSet = sizes.filter((size) => size.width).map((size) => `${size.url} ${size.width}w`)
  return srcSet.join(', ')
}